import { ChartConstructorType } from 'highcharts-angular';
import { DashboardGaugeDto } from './../../../../service/dto';
import { Component, Input } from "@angular/core";

@Component({
	selector: 'app-dashboard-gauge',
	standalone: false,
	templateUrl: './dashboard-gauge.component.html',
	styleUrl: './dashboard-gauge.component.scss'
})
export class DashboardGaugeComponent {
	@Input() input!: DashboardGaugeDto;
}
